import { Mutation } from "../types";
import { LockSession } from "@/framework/types/LockSession";
import { LocationInfo } from "@/modules/staff/objects/roomConversation";

export default {
  [Mutation.SET_STATE_OF_CHATS_WITH_STAFF](state: any, payload: string) {
    state.stateOfChatsWithStaff = payload;
  },
  [Mutation.SET_DISPLAY_PROMPT_COMPLETE_SERVICE](state: any, payload: boolean) {
    state.displayPromptCompleteService = payload;
  },
  [Mutation.SET_CHECKIN](state: any, payload: any) {
    state.checkin = payload;
  },
  [Mutation.SET_ADMIN_CHANGED](state: any, payload: boolean) {
    state.adminChanged = payload;
  },
  [Mutation.SET_ADMIN_SUB_CHANGED](state: any, payload: boolean) {
    state.adminSubChanged = payload;
  },
  // just store the ID- even if we need the whole object, we can use the ID to find via the myself.tenant store object
  [Mutation.SET_CURRENT_GROUP_ID](state: any, payload: number) {
    state.currentGroupId = payload;
  },
  [Mutation.SET_BOT_DICT_UPDATED_IDX](state: any, payload: number) {
    state.botDictUpdatedIdx = payload;
  },
  [Mutation.SET_MENU_PATH](state: any, payload: any) {
    state.menuPath = payload;
  },
  [Mutation.SET_OPEN_GUEST_INPUT](state: any, payload: any) {
    state.guestInputData = payload;
  },
  [Mutation.SET_BIZ_FACILITY](state: any, payload: any) {
    state.facility = payload;
  },
  [Mutation.SET_SELECTED_MENU](state: any, payload: any) {
    state.selectedMenu = payload;
  },
  [Mutation.SET_PREVIOUS_MENU](state: any, payload: any) {
    state.previousMenu = payload;
  },
  [Mutation.SET_TRIPADVISOR_DOMAIN](state: any, payload: string) {
    state.tripadvisorDomain = payload;
  },
  [Mutation.SET_OPEN_HOTEL_MENU](state: any) {
    state.openHotelMenu = !state.openHotelMenu;
  },
  [Mutation.SET_COUPONS](state: any, payload: {}) {
    state.coupons = payload;
  },
  [Mutation.SET_LOCK_SESSION](state: any, payload: LockSession) {
    state.lockSession = payload;
  },
  [Mutation.SET_TENANT_ID](state: any, payload: any) {
    state.tenantId = payload;
  },
  [Mutation.SET_TENANT_LANG_CD](state: any, payload: any) {
    state.tenantLangCd = payload;
  },
  [Mutation.SET_ADMIN_TENANT_FLG](state: any, payload: any) {
    state.adminTenantFlg = payload;
  },
  [Mutation.SET_INPUT_ROOM_NO_BEFORE_CONVERSATION](state: any, payload: any) {
    state.inputRoomNoBeforeConversation = payload;
  },
  [Mutation.SET_TENANT_INFO](state: any, payload: any) {
    state.tenantInfo = payload;
  },
  [Mutation.SET_STORE_LOCATION_INFO](state: any, payload: LocationInfo) {
    state.storeLocationInfo = payload;
  },
  [Mutation.SET_CMS_COUPON_OPTION](state: any, payload: any) {
    state.cmsCouponOption = payload;
  },
  [Mutation.STOP_CHECKING_IMPORT_PROCESS](state: any, payload: any) {
    state.stopCheckingImportProcess = payload;
  },
  [Mutation.SET_ICON_COLOR](state: any, payload: any) {
    state.iconColor = payload;
  },
};
